import {
  ExperimentsAction,
  ExperimentAnalyticsLoadingState,
  ExperimentAnalyticsErrorState,
  ExperimentAnalyticsPerformanceTabState,
} from 'modules/experiments/types';
import { initialAnalyticsPerformanceTabData } from 'modules/experiments/constants';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

export const initialAnalyticsPerformanceTabState: ExperimentAnalyticsPerformanceTabState = {
  data: initialAnalyticsPerformanceTabData,
  [ExperimentAnalyticsLoadingState.PERFORMANCE_TAB]: false,
  [ExperimentAnalyticsErrorState.PERFORMANCE_TAB]: false,
};

export const experimentAnalyticsPerformanceTabReducer = (
  state = initialAnalyticsPerformanceTabState,
  action?: ExperimentsAction,
) => {
  switch (action?.type) {
    case ActionTypes.ANALYTICS_PAGE_PERFORMANCE_TAB_LOADED:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PERFORMANCE_TAB]: true,
      };

    case ActionTypes.SET_ANALYTICS_PERFORMANCE_TAB_DATA: {
      const performanceTabData = action?.payload;
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PERFORMANCE_TAB]: false,
        [ExperimentAnalyticsErrorState.PERFORMANCE_TAB]: false,
        data: performanceTabData || state.data,
      };
    }

    case ActionTypes.ANALYTICS_RELOAD_PERFORMANCE_TAB_DATA:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PERFORMANCE_TAB]: true,
        [ExperimentAnalyticsErrorState.PERFORMANCE_TAB]: false,
      };

    case ActionTypes.ANALYTICS_PERFORMANCE_TAB_DATA_LOADED:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PERFORMANCE_TAB]: false,
      };

    case ActionTypes.ANALYTICS_PERFORMANCE_TAB_DATA_ERROR:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PERFORMANCE_TAB]: false,
        [ExperimentAnalyticsErrorState.PERFORMANCE_TAB]: true,
      };

    default:
      return state;
  }
};
